interface IGroupRadioButtonProps {
  label?: string;
  value: string;
  options: string[];
  name: string;
  className?: string;
  onChange?: (v: string) => void;
}

const GroupRadioButton: React.FunctionComponent<IGroupRadioButtonProps> = ({
  label = "",
  value = "",
  options = [],
  name = "",
  className = "",
  onChange = () => {},
}) => {
  return (
    <div>
      <p className="text-sm font-semibold mb-2">{label}</p>
      <article className={`flex ${className} gap-4`}>
        {options.map((option, i) => (
          <label className="flex gap-2" key={`${i}-${option}`}>
            <input
              type="radio"
              value={option}
              name={name}
              onChange={(e) => onChange(e.target.value)}
            />
            <span className="text-sm">{option}</span>
          </label>
        ))}
      </article>
    </div>
  );
};

export default GroupRadioButton;
